<div class="dialog-container" id="vital-report-modal">
  <div class="header-title">Generate Vital Records Report</div>
  <form [formGroup]="formGroup" (ngSubmit)="onGenerate()">
    <div class="form-container">
      <div class="input-container">
        <div class="input-group">
          <ptg-datepicker
            [controlField]="formGroup.get('fromDate')"
            placeholder="From Date"
            class="input-from-date"
            [isRequired]="true"
            errorRequire="From Date is required"
          ></ptg-datepicker>
          <ptg-datepicker
            [controlField]="formGroup.get('toDate')"
            placeholder="To Date"
            class="input-to-date"
            [isRequired]="true"
            errorRequire="To Date is required"
          ></ptg-datepicker>
        </div>
      </div>
      <div *ngIf="isGenerating" class="processing-message">
        <mat-spinner diameter="30"></mat-spinner>
        <span>Processing report...</span>
      </div>
    </div>
    <div class="row-button">
      <button 
        class="submit-button" 
        mat-raised-button 
        type="submit"
        [disabled]="isGenerating"
      >
        Generate Report
      </button>
      <button 
        (click)="onCancel()" 
        class="cancel-button" 
        mat-raised-button 
        type="button"
        [disabled]="isGenerating"
      >
        Cancel
      </button>
    </div>
  </form>
</div>
